interface AccordionInterface {
	container: HTMLElement;
	items: NodeListOf<HTMLElement>;
	closeItem( item: HTMLElement ): void;
	openItem( item: HTMLElement ): void;
	toggleItem( item: HTMLElement ): void;
}

export const initAccordionBlock = ( el: HTMLElement ): AccordionInterface => {
	const Object = {
		container: el,
		items: el.querySelectorAll( '.accordion-item' ) as NodeListOf<HTMLElement>,

		_init: function () {
			console.log( 'Init Accordion: ', this.container, this.items );

			this._bindClass();
			this._bindEvents();

			const firstItem = this.items[0];

			if (firstItem)
				this.openItem( firstItem );
		},

		_bindClass(): void {
			this.toggleItem = this.toggleItem.bind(this);
		},

		_bindEvents(): void {
			this.items.forEach( (item: HTMLElement) => {
				item.addEventListener(
					'click',
					() => this.toggleItem( item )
				);
			} );
		},

		closeItem( item: HTMLElement ): void {
			item.classList.remove('accordion-item--open');
		},

		openItem( item: HTMLElement ): void {
			item.classList.add('accordion-item--open');
		},

		toggleItem( item: HTMLElement ): void {
			this.items.forEach( ( itemToClose: HTMLElement ) => {
				if ( itemToClose !== item )
					this.closeItem( itemToClose );
			});

			this.openItem( item );
		},

	};

	Object._init();
	return Object;
};

export const initAccordionBlocks = ( selectors = '.accordion' ): void => {
	const blocks = document.querySelectorAll( selectors ) as NodeListOf<HTMLElement>;

	blocks.forEach(
		( el: HTMLElement ) => initAccordionBlock( el )
	);
};
